import { render, staticRenderFns } from "./ColdClientTableFilter.vue?vue&type=template&id=07606daa&"
import script from "./ColdClientTableFilter.vue?vue&type=script&lang=js&"
export * from "./ColdClientTableFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports